import React, { Component } from 'react';
import { bindActionCreators } from 'redux';
import { connect } from 'react-redux';
import { reduxForm, Field, formValueSelector, getFormValues } from 'redux-form';

import Content from '../common/template/content';
import ContentCard from '../common/template/contentCard';
import ContentCardHeader from '../common/template/contentCardHeader';
import ContentCardBody from '../common/template/contentCardBody';
import ContentCardFooter from '../common/template/contentCardFooter';
import Row from '../common/layout/row';
import Grid from '../common/layout/grid';
import Button from '../common/button/button';
import Form from '../common/form/form';
import LabelAndInput from '../common/form/labelAndInput';
import LabelAndInputNumber from '../common/form/labelAndInputNumber';
import LabelAndInputMask from '../common/form/labelAndInputMask';
import LabelAndInputDateTime from '../common/form/labelAndInputDateTime';
import Select from '../common/form/select';
import SelectAlteracao from '../common/form/selectAlteracao';
import ColorSelector from '../common/form/colorSeletor';

import {
	setModoTela, initForm
} from './processoStatusActions';

class ProcessoStatusForm extends Component {

	state = {

	}

    componentWillMount() {

    }

    render() {

		let readOnly = this.props.excluir ? 'readOnly' : '';

        return (
			<ContentCard>
				<Form event={this.props.handleSubmit}>
					<ContentCardBody>
						<Row>
							<Field
								name='nome'
								component={LabelAndInput}
								label='Nome *' placeholder='Informe o nome'
								cols='12 12 12 12'
								readOnly={readOnly} />
						</Row>

						<Row>
							<Select
								name='finalizado'
								options={this.props.listaSimNao}
								label='Finaliza o Processo'
								cols='12 6 6 6'
								placeholder='Selecione se finaliza o processo'
								readOnly={readOnly}
								value={this.props.formularioValues.finalizado ? 2 : 1}
								onChange={data => {
									this.props.initForm({
										...this.props.formularioValues,
										finalizado: data == 2
									})
								}} />
						</Row>

						<Row>
							<Field
								name='cor'
								component={ColorSelector}
								label='Cor'
								cols='12 10 6 4'
								readOnly={readOnly}
								color={this.props.formularioValues.cor || '#fff'}
								complete={(color) => {
									this.props.initForm({ ...this.props.formularioValues, cor: color.hex });
								}} />
						</Row>

					</ContentCardBody>
					<ContentCardFooter>
						<Row alignCenter>
							<Grid cols='6 6 4 3'>
								{this.props.excluir ? (
									<Button
										text='Excluir'
										submit type={'danger'}
										icon={'fa fa-trash'} />
								) : (
								<Button
									text='Salvar'
									submit
									type={'success'}
									icon={'fa fa-check'} />
								)}
							</Grid>
							<Grid cols='6 6 4 3'>
								<Button
									text='Voltar'
									type={'warning'}
									icon={'fa fa-chevron-left'}
									event={() => this.props.setModoTela('lista')} />
							</Grid>
						</Row>
					</ContentCardFooter>
				</Form>
			</ContentCard>
        )
    }


}

ProcessoStatusForm = reduxForm({form: 'processoStatusForm', destroyOnUnmount: false})(ProcessoStatusForm);
const mapStateToProps = state => ({
	sessao: state.auth.usuario,
	formularioValues: getFormValues('processoStatusForm')(state),
	registro: state.processoStatus.registro,
	listaSimNao: state.processoStatus.listaSimNao
});
const mapDispatchToProps = dispatch => bindActionCreators({
	setModoTela, initForm
}, dispatch);
export default connect(mapStateToProps, mapDispatchToProps)(ProcessoStatusForm);
